import {Component} from '@angular/core';

@Component({
  selector: 'frontend-checkbox-episode',
  templateUrl: './checkbox-episode.component.html',
  styleUrls: ['./checkbox-episode.component.scss'],
})
export class CheckboxEpisodeComponent {
}
